<template>
  <div>
    <!-- * ========== Formulario Principal ========== * -->
    <v-row>
      <!-- ~ ========== Subir XML ========== ~ -->
      <v-col md="2" cols="12">
        <v-card
          v-if="Compra.sts != 'A' && Compra.sts != 'C'"
          :disabled="edit"
          elevation="2"
          rounded="xl"
          height="100%"
          class="d-flex align-center"
        >
          <v-card-text class="text-center">
            <v-btn
              v-if="!edit && Compra.sts != 'A' && Compra.sts != 'C'"
              color="indigo"
              class="mt-1"
              dark
              block
              @click="uploadFile()"
            >
              Subir XML
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- ~ ========== Datos de la Compra ========== ~ -->
      <v-col md="8" cols="12">
        <v-card elevation="2" rounded="xl">
          <v-card-text>
            <v-form ref="formPresentacion">
              <v-row :no-gutters="$vuetify.breakpoint.mdAndDown" class="mt-0">
                <!-- + ========== Tipo de Compra ========== + -->
                <v-col cols="12" md="6">
                  <v-autocomplete
                    outlined
                    dense
                    @change="changeOrdenCompra()"
                    label="Tipo"
                    v-model="tipoOrden"
                    :rules="rules.Requerido"
                    :items="types"
                    item-text="name"
                    item-value="id"
                    readonly
                  >
                  </v-autocomplete>
                </v-col>
                <!-- + ========== Subir PDF ========== + -->
                <v-col md="6" cols="12">
                  <v-btn
                    :disabled="!Compra.adq || Compra.adq.length === 0"
                    color="red"
                    class="white--text mb-4"
                    block
                    @click="uploadPDF()"
                  >
                    {{ archivoPdf ? "Cambiar PDF" : "Subir PDF" }}
                  </v-btn>
                </v-col>
                <!-- + ========== Departamento ========== + -->
                <v-col md="3" cols="12">
                  <v-autocomplete
                    v-model="Compra.dpt"
                    outlined
                    dense
                    label="Departamento"
                    ref="dptField"
                    :rules="rules.Requerido"
                    :items="modulos"
                    @change="updateAllDpt"
                  >
                  </v-autocomplete>
                </v-col>
                <!-- + ========== Almacén ========== + -->
                <v-col md="3" cols="12">
                  <v-autocomplete
                    outlined
                    dense
                    :disabled="!editableAmc"
                    label="Almacén"
                    v-model="Compra.amc"
                    :rules="rules.Requerido"
                    :items="origenes"
                    item-text="Nombre"
                    item-value="id"
                    @change="updateAllAmc"
                  >
                  </v-autocomplete>
                </v-col>
                <!-- + ========== Descripción ========== + -->
                <v-col md="3" cols="12">
                  <v-text-field
                    outlined
                    dense
                    label="Descripción"
                    v-model="Compra.dsc"
                  >
                  </v-text-field>
                </v-col>
                <!-- + ========== Notas ========== + -->
                <v-col md="3" cols="12" :disabled="Compra.sts != 'P'">
                  <v-textarea
                    outlined
                    dense
                    label="Notas de la compra"
                    v-model="notasProds"
                    rows="1"
                    hide-details
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- ~ ========== Acciones ========== ~ -->
      <v-col md="2" cols="12">
        <v-card
          v-if="Compra.sts != 'A' && Compra.sts != 'C'"
          elevation="2"
          rounded="xl"
          class="d-flex align-center"
          height="100%"
        >
          <v-card-text>
            <v-btn v-if="false" @click="$emit('toggle', false)" class="px-1">
              Cerrar
            </v-btn>
            <v-btn
              v-if="edit && Compra.sts != 'A' && Compra.sts != 'C'"
              block
              color="orange"
              dark
              @click="aplicarCompra()"
            >
              Aplicar
            </v-btn>
            <v-btn
              v-if="Compra.sts != 'A' && Compra.sts != 'C'"
              :disabled="
                !Compra.dpt ||
                !Compra.amc ||
                !Compra.adq ||
                Compra.adq.length == 0 ||
                this.editableDepAlmList.length > 0
              "
              :light="!Compra.dpt || !Compra.amc"
              color="success"
              class="mt-1"
              block
              @click="saveOrdenCompra()"
            >
              Guardar Compra
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- * ========== Alert Departamento ========== * -->
    <v-expand-transition>
      <v-alert
        v-show="!Compra.dpt || !Compra.amc"
        type="warning"
        border="left"
        class="mt-2"
        prominent
        outlined
      >
        Selecciona un <strong> Departamento </strong> y un
        <strong> Almacén </strong> para continuar con la compra
      </v-alert>
    </v-expand-transition>

    <!-- * ========== Alert Subir XML ========== * -->
    <v-expand-transition>
      <v-alert
        v-show="Compra.dpt && Compra.amc && !Compra.adq.length"
        type="info"
        border="left"
        class="mt-2"
        prominent
        outlined
      >
        Sube un <strong> Archivo XML </strong> para continuar con la compra
      </v-alert>
    </v-expand-transition>

    <!-- * ========== Detalles de la Compra ========== * -->
    <v-expand-transition>
      <v-card
        v-show="Compra.adq && Compra.adq.length"
        class="mt-2"
        elevation="2"
        rounded="xl"
      >
        <v-card-text>
          <!-- ~ ========== Proveedor Encontrado ========== ~ -->
          <v-alert
            v-if="proveedor.Rfc != null && !proveedor.notFinded"
            type="info"
            border="left"
            class="my-3 py-3"
            colored-border
            dense
            prominent
          >
            Proveedor: <strong> {{ proveedor.Nombre }} </strong> de RFC:
            <strong> {{ proveedor.Rfc }} </strong>
          </v-alert>

          <!-- ~ ========== Sin Proveedor ========== ~ -->
          <v-alert
            v-if="proveedor.notFinded"
            type="error"
            border="left"
            class="my-3"
            dense
            text
          >
            El proveedor con el RFC: <strong> {{ proveedor.Rfc }} </strong> no
            existe para esta compra
          </v-alert>

          <!-- ~ ========== Detalles de la Compra ========== ~ -->
          <div v-if="Compra.adq && !proveedor.notFinded">
            <h4>
              Requerimientos || Total:{{ total.compra }} || Total XML:
              {{ total.XML }}
            </h4>
            <v-row class="my-2" dense>
              <!-- + ========== Resumen ========== + -->
              <v-col
                v-for="(grupo, grupoIndex) in agrupadosPorProveedor"
                :key="'grupo-' + grupoIndex"
                cols="12"
              >
                <v-card class="mb-4" outlined>
                  <v-card-title class="grey lighten-3 py-1">
                    <span class="text-body-1">
                      <strong>{{ grupo.proveedor }}</strong> - Totales:
                      {{ grupo.total }}
                    </span>
                  </v-card-title>

                  <v-divider></v-divider>

                  <!-- + ========== Productos ========== + -->
                  <v-card-text>
                    <v-list dense>
                      <v-list-item
                        v-for="(pres, index) in grupo.items"
                        :key="'item-' + index"
                      >
                        <v-list-item-content>
                          <v-row :no-gutters="$vuetify.breakpoint.mdAndDown">
                            <!-- + ========== Producto e Identificador by XML ========== + -->
                            <v-col cols="12" md="6" class="py-1">
                              <v-row
                                :class="
                                  !pres.prd || !pres.prs ? 'red--text' : ''
                                "
                                no-gutters
                              >
                                <v-col cols="12" md="12">
                                  <span class="font-weight-bold">
                                    Nombre:
                                  </span>
                                  <span>{{ pres.prodNombre }}</span>
                                </v-col>
                                <v-col cols="12" md="12">
                                  <span class="font-weight-bold">
                                    NoIdentificador:
                                  </span>
                                  <span>{{ pres.cfc }}</span>
                                </v-col>
                                <v-col cols="12" md="12">
                                  <span class="font-weight-bold">
                                    Departamento:
                                  </span>
                                  <span
                                    :class="{
                                      'blue--text': !changeDepAlmcList.includes(
                                        `${pres.cfc}`
                                      ),
                                      'orange--text text-darken-3':
                                        changeDepAlmcList.includes(
                                          `${pres.cfc}`
                                        ),
                                    }"
                                  >
                                    {{ findDptInfo(pres.dpt).Nombre }}
                                  </span>
                                </v-col>
                                <v-col cols="12" md="12">
                                  <span class="font-weight-bold">
                                    Almacén:
                                  </span>
                                  <span
                                    :class="{
                                      'blue--text': !changeDepAlmcList.includes(
                                        `${pres.cfc}`
                                      ),
                                      'orange--text text-darken-3':
                                        changeDepAlmcList.includes(
                                          `${pres.cfc}`
                                        ),
                                    }"
                                  >
                                    {{ findAmcInfo(pres.amc).Nombre }}
                                  </span>
                                </v-col>
                              </v-row>
                            </v-col>
                            <!-- + ========== Alerta de cambios ========== + -->
                            <v-col cols="12" md="6" class="py-1">
                              <span
                                v-if="
                                  !changeDepAlmcList.includes(`${pres.cfc}`)
                                "
                              ></span>
                              <v-alert
                                v-else
                                border="left"
                                color="blue"
                                type="info"
                                outlined
                                text
                              >
                                <span>
                                  El producto se dirige a un departamento y/o
                                  almacen distinto al seleccionado
                                </span>
                              </v-alert>
                            </v-col>
                            <!-- + ========== Producto  ========== + -->
                            <v-col cols="12" md="2">
                              <v-autocomplete
                                v-model="pres.prd"
                                outlined
                                dense
                                label="Producto"
                                :rules="rules.Requerido"
                                :items="insumosByPresPrd"
                                :disabled="pres.block"
                                item-text="Nombre"
                                item-value="id"
                                @change="pres.prs = null"
                              />
                            </v-col>
                            <!-- + ========== Presentación ========== + -->
                            <v-col cols="12" md="3" class="d-flex">
                              <v-autocomplete
                                outlined
                                dense
                                :disabled="Compra.sts == 'A' || pres.block"
                                :items="presentacionesFiltradasPorPrd(pres.prd)"
                                :key="`prs-${index}-${pres.prd}`"
                                :hint="
                                  pres.prs
                                    ? presentacionesByPvdId.pres.filter(
                                        (presen) => presen.Id == pres.prs
                                      )[0].title
                                    : ''
                                "
                                item-text="title"
                                item-value="Id"
                                label="Presentación"
                                v-model="pres.prs"
                                persistent-hint
                              />
                              <v-btn
                                v-if="pres.block"
                                :disabled="!pres.block"
                                color="pink"
                                class="ml-1"
                                outlined
                                icon
                                @click="
                                  pres.block = !pres.block;
                                  pres.prs = null;
                                "
                              >
                                <v-icon>{{
                                  pres.block ? "mdi-lock" : "mdi-lock-open"
                                }}</v-icon>
                              </v-btn>
                            </v-col>

                            <!--    <v-col cols="6" md="1" class="px-1 px-md-3">
                              <v-text-field
                                :value="getProductUnidad(pres, pres.cnt)"
                                label="Total"
                                outlined
                                dense
                                readonly
                                flat
                              ></v-text-field>
                            </v-col> -->
                            <!-- + ========== Total ========== + -->
                            <v-col cols="12" md="1" class="px-1 px-md-3">
                              <div
                                class="d-flex flex-column justify-center text--darken-3 my-4 my-md-1"
                              >
                                <span
                                  class="text-body-2 font-weight-medium mt-n2 mb-1"
                                >
                                  Total
                                </span>
                                <span class="text-body-2">
                                  {{ getProductUnidad(pres, pres.cnt) }}
                                </span>
                              </div>
                            </v-col>
                            <!-- + ========== Cantidad ========== + -->
                            <v-col cols="12" md="1" class="px-1 px-md-3">
                              <div
                                class="d-flex flex-column justify-center text--darken-3 my-4 my-md-1"
                              >
                                <span
                                  class="text-body-2 font-weight-medium mt-n2 mb-1"
                                >
                                  Cantidad
                                </span>
                                <span class="text-body-2">
                                  {{ pres.cnt }}
                                </span>
                              </div>
                            </v-col>
                            <!-- + ========== Precio Unitario ========== + -->
                            <v-col cols="12" md="1" class="px-1 px-md-3">
                              <div
                                class="d-flex flex-column justify-center text--darken-3 my-4 my-md-1"
                              >
                                <span
                                  class="text-body-2 font-weight-medium mt-n2 mb-1"
                                >
                                  Precio Unitario
                                </span>
                                <span class="text-body-2">
                                  {{ pres.pcu.C }}
                                </span>
                                <span class="red--text text--darken-3 mt-1">
                                  {{
                                    sobreCostoByPrs[pres.prs]
                                      ? "Supera el doble del costo promedio"
                                      : ""
                                  }}
                                </span>
                              </div>
                            </v-col>
                            <!-- + ========== Costo Prom. Actual ========== + -->
                            <v-col
                              cols="12"
                              md="2"
                              class="d-flex justify-md-center"
                            >
                              <div
                                class="d-flex flex-column text--darken-3 my-4 my-md-1"
                              >
                                <span
                                  class="text-body-2 font-weight-medium mt-n2 mb-1"
                                >
                                  Costo prom. actual
                                </span>
                                <span class="text-body-2">
                                  {{
                                    costoRefByPrs[pres.prs] != null
                                      ? $pgsHelper.formatNumber(
                                          costoRefByPrs[pres.prs]
                                        )
                                      : "-"
                                  }}
                                </span>
                              </div>
                            </v-col>
                            <!-- + ========== Importe ========== + -->
                            <v-col cols="12" md="1" class="px-1 px-md-3">
                              <div
                                class="d-flex flex-column justify-center text--darken-3 my-4 my-md-1"
                              >
                                <span
                                  class="text-body-2 font-weight-medium mt-n2 mb-1"
                                >
                                  Importe
                                </span>
                                <span class="text-body-2">
                                  {{ pres.precioTotal }}
                                </span>
                              </div>
                              <!-- <v-text-field
                                v-model="pres.precioTotal"
                                label="Importe"
                                outlined
                                dense
                                readonly
                              ></v-text-field> -->
                            </v-col>
                            <!-- + ========== Editar Dept y Almacén ========== + -->
                            <v-col
                              v-if="!editableDepAlmList.includes(pres.cfc)"
                              cols="12"
                              md="1"
                            >
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    :size="
                                      $vuetify.breakpoint.mdAndDown
                                        ? 'small'
                                        : undefined
                                    "
                                    v-bind="attrs"
                                    v-on="on"
                                    color="indigo"
                                    class="white--text mb-4 mb-md-1"
                                    rounded
                                    @click="editableDept(pres.cfc)"
                                  >
                                    <v-icon start> mdi-pencil </v-icon>
                                  </v-btn>
                                </template>
                                <span> Editar Almacenaje </span>
                              </v-tooltip>
                            </v-col>
                            <!-- + ==========  Departamento y Almacen  ========== + -->
                            <template
                              v-if="editableDepAlmList.includes(`${pres.cfc}`)"
                            >
                              <v-col md="3" cols="12" class="py-0">
                                <v-autocomplete
                                  v-model="pres.dpt"
                                  :items="modulos"
                                  label="Departamento"
                                  ref="dptField"
                                  outlined
                                  dense
                                  clearable
                                  hide-details
                                >
                                </v-autocomplete>
                              </v-col>
                              <v-col md="3" cols="12" class="py-0">
                                <v-autocomplete
                                  v-model="pres.amc"
                                  label="Almacén"
                                  :disabled="!editableAmc"
                                  :items="origenes"
                                  item-text="Nombre"
                                  item-value="id"
                                  outlined
                                  dense
                                  clearable
                                  hide-details
                                >
                                </v-autocomplete>
                              </v-col>
                              <v-col
                                md="4"
                                cols="12"
                                class="d-flex justify-start align-center py-0"
                              >
                                <v-tooltip
                                  v-if="changeDepAlmcList.includes(pres.cfc)"
                                  top
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      :size="
                                        $vuetify.breakpoint.mdAndDown
                                          ? 'small'
                                          : undefined
                                      "
                                      v-bind="attrs"
                                      v-on="on"
                                      color="green"
                                      class="white--text mb-4 mb-md-1 mr-3"
                                      rounded
                                      @click="confirmEditable(pres.cfc)"
                                    >
                                      <v-icon start> mdi-check </v-icon>
                                    </v-btn>
                                  </template>
                                  <span> Guardar </span>
                                </v-tooltip>
                              </v-col>
                            </template>
                            <!-- + ==========  Divider  ========== + -->
                            <v-col cols="12" md="12" class="pt-0 my-4">
                              <v-divider />
                            </v-col>
                            <v-col v-if="false" cols="12" md="1" class="mb-3">
                              <v-btn
                                @click="deleteInsumo(pres.globalIndex)"
                                v-if="Compra.sts != 'A'"
                                outlined
                                color="red"
                              >
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <ag-grid-vue
              v-if="false"
              style="height: 300px"
              class="ag-theme-alpine"
              :columnDefs="columnDefs"
              rowSelection="single"
              :rowData="Compra.adq"
              @gridReady="ongridReady($event)"
              @selection-changed="onSelectionChanged($event)"
            >
            </ag-grid-vue>
            <!--             <v-alert
              v-if="Compra.adq.length == 0"
              border="bottom"
              colored-border
              type="info"
              elevation="1"
            >
              La Compra esta vacia.
            </v-alert> -->
          </div>
        </v-card-text>
      </v-card>
    </v-expand-transition>

    <v-file-input
      ref="hiddenFileInput"
      v-model="selectedFile"
      :accept="acceptedDocuments"
      :multiple="multipleDocuments"
      truncate-length="15"
      class="d-none"
      dense
      outlined
      @change="onFileSelected"
    />
  </div>
</template>

<script>
import Compra from "../../../clases/Inventarios/Compras.js";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import moment from "moment";
import Currency from "../../../clases/Currencies.js";
import { XMLParser } from "fast-xml-parser";
export default {
  name: "ComprasXml",
  components: { AgGridVue },
  props: ["edit", "dataEdit", "presentaciones", "presentacionesAll"],
  data() {
    return {
      selectedFile: null,
      archivoPdf: null,
      changeDepAlmcList: [],
      editableDepAlmList: [],
      acceptedDocuments: null,
      multipleDocuments: false,
      dataFromXml: null,
      proveedor: {
        Rfc: null,
        notFinded: false,
        id: null,
      },
      XMLtotal: 0,

      notasProds: "",

      monedas: Currency.getCurrencies(),
      origenes: [],
      tipoOrden: "A",
      estatusList: Compra.getStatusList(),
      types: Compra.getTypes(),
      Compra: Compra.getPropertyModel(),
      rules: Compra.getRules(),
      columnDefs: null,
      editableAmc: true,
      prodSelected: null,
      reqToAdd: {
        presentacion: { prd: null, rdm: null },
        prd: null,
        prs: "",
        nom: "",
        cnt: 0,
        pcu: { C: 0, M: "MXN" },
      },
      toAddForm: 0,
      selection: [],
      OrdenesCompra: [],
      /*presentacion: PresentacionesAYB.getPropertyModel(),
      presentaciones:[],
      rules:PresentacionesAYB.getRules(),*/
      Proveedores: [],
      costos: {},
      snackDptMissing: false,
    };
  },
  methods: {
    editableDept(cfc) {
      if (!this.changeDepAlmcList.includes(`${cfc}`)) {
        this.changeDepAlmcList.push(`${cfc}`);
      }

      if (!this.editableDepAlmList.includes(`${cfc}`)) {
        this.editableDepAlmList.push(`${cfc}`);
      }

      /* const findIndex = this.changeDepAlmcList.findIndex(
        (item) => item === `${cfc}`
      );

      if (findIndex !== -1) {
        this.Compra.adq[findIndex].dpt = this.Compra.dpt;
        this.Compra.adq[findIndex].amc = this.Compra.amc;
      }

      this.changeDepAlmcList = this.changeDepAlmcList.filter(
        (item) => item !== `${cfc}`
      ); */
    },
    confirmEditable(cfc) {
      this.editableDepAlmList = this.editableDepAlmList.filter(
        (item) => item !== `${cfc}`
      );

      const findIndex = this.changeDepAlmcList.findIndex(
        (item) => item === `${cfc}`
      );

      if (findIndex !== -1) {
        if (
          !this.Compra.adq[findIndex].dpt ||
          !this.Compra.adq[findIndex].amc ||
          (this.Compra.adq[findIndex].dpt == this.Compra.dpt &&
            this.Compra.adq[findIndex].amc == this.Compra.amc)
        ) {
          this.changeDepAlmcList = this.changeDepAlmcList.filter(
            (item) => item !== `${cfc}`
          );

          this.Compra.adq[findIndex].dpt = this.Compra.dpt;
          this.Compra.adq[findIndex].amc = this.Compra.amc;
        }
      }
    },
    cancelEditable(cfc) {
      this.confirmEditable(cfc);

      const findIndex = this.changeDepAlmcList.findIndex(
        (item) => item === `${cfc}`
      );

      if (findIndex !== -1) {
        this.Compra.adq[findIndex].dpt = this.Compra.dpt;
        this.Compra.adq[findIndex].amc = this.Compra.amc;
      }

      this.changeDepAlmcList = this.changeDepAlmcList.filter(
        (item) => item !== `${cfc}`
      );
    },
    async getCostos() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("PDV_Costos", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);
      let globalCosto = {};
      let costos = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      costos.forEach((element) => {
        let prod = Object.entries(element.pds);
        prod.forEach((pd) => {
          if (!globalCosto[pd[0]]) {
            globalCosto[pd[0]] = [];
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          } else {
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          }
        });
      });
      this.costos = globalCosto;
    },
    getCostoRef(prod) {
      const idProd = prod.prd;
      const arr = this.costos && this.costos[idProd];
      // si no hay costos
      if (!arr || !arr.length) return null;
      const dpt = this.Compra && this.Compra.dpt;
      // filtramos por depto si viene definido en la compra
      const filtered =
        dpt != null
          ? arr.filter(
              (e) =>
                String(e && e.depto)
                  .trim()
                  .toUpperCase() === String(dpt).trim().toUpperCase()
            )
          : arr;
      // si no hubo match por depto, no hay dato
      if (!filtered.length) return null;
      // sacamos la suma de los costos (mantengo tu lógica original)
      const sum = filtered.reduce(
        (s, i) => s + (Number(i && i.uct && i.uct.C) || 0),
        0
      );
      // regresamos el promedio
      return sum / filtered.length;
    },
    resetForm() {
      this.prodSelected = null;
      this.reqToAdd = {
        prd: null,
        prs: "",
        nom: "",
        cnt: "",
        pcu: { C: 0, M: "MXN" },
      };
    },
    async getOrdenesCompra() {
      this.Documentos = [];
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("AMC_OrdenesCompra", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);

      //this.$pgsHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
      let document = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      document.forEach((data) => {
        /* let dateFormat = new firestore.Timestamp(
          data.FechaCreacion.seconds,
          data.FechaCreacion.nanoseconds
        );*/
        let fecha = new moment(data.mmt, "YYYY-MM-DD_HH:mm:ss");
        //let origenData = this.getOrigenById(data.amc);
        this.Documentos.push({
          id: data.id,
          //origenId: origenData.id,
          //origenNombre: origenData.Nombre,
          Nombre: "OC - " + fecha.format("YYYY-MM-DD HH:mm"),
          Fecha: fecha.format("YYYY-MM-DD HH:mm"),
          //Departamento: data.Departamentos[0],
          Aplicado: data.sts,
          Status: data.sts == "F" ? "Completado" : "Pendiente",
          ...data,
        });
      });

      this.OrdenesCompra = this.$_.orderBy(this.Documentos, "Fecha", "desc");
    },
    deleteInsumo(index) {
      this.Compra.adq.splice(index, 1);
    },
    onSelectionChanged(params) {
      const selectedRows = params.api.getSelectedRows();

      this.selection = selectedRows;
    },
    ongridReady: function (params) {
      let gridApi = params.api;
      gridApi.sizeColumnsToFit();
      let gridColumnApi = params.columnApi;
    },
    async getOrigenes() {
      var data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Inventario/Origenes"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayOrg = Object.entries(data.val());
      let origenes = [];
      arrayOrg.forEach((element) => {
        if (!this.$route.params.idDocumento) {
          this.Origen = element[0];
        }
        //this.Origen =  element[0];
        origenes.push({
          id: element[0],
          Nombre: element[1]["Nombre"],
          Departamentos: element[1]["Departamentos"],
        });
      });

      this.origenes = origenes;
    },
    saveOrdenCompra() {
      if (this.$refs.formPresentacion.validate()) {
        this.Compra.adq.forEach((prod) => {
          prod.cnt = Number(prod.cnt);
          prod.pcu.C = Number(prod.pcu.C);
          prod.nom = this.presentacionesByPvdId.pres.find(
            (p) => p.Id == prod.prs
          ).nom;
        });
        this.Compra.mmt = new moment().format("YYYY-MM-DD_HH:mm:ss");
        this.Compra.nts = this.notasProds;
        this.Compra.uuid = this.dataFromXml.document.UUID || "";
        let datos = this.Compra;
        this.$alert.alertConfirm({
          action: this.edit ? "guardar" : "agregar",
          obj: "la compra",
          route: this.edit
            ? "AMC-Compras-updateCompra"
            : "AMC-Compras-createCompra",
          data: datos,
          onSuccess: async (response) => {
            if (response.data.ok && this.archivoPdf != null) {
              const formData = new FormData();
              formData.append("Documentos[]", this.archivoPdf);
              formData.append(
                "Tenant",
                this.$store.getters.getFirebaseApp.tenant
              );
              formData.append("CompraId", response.data.data.id);

              this.$swal({
                allowOutsideClick: false,
                text: `Se guardará el archivo PDF ${this.archivoPdf.name} en la compra`,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Sí, guardar",
                cancelButtonText: "Cancelar",
                showLoaderOnConfirm: true,
                preConfirm: async () => {
                  try {
                    return await this.$store.getters.getFirebaseApp.fba.callForm(
                      "AMC-Compras-uploadDocumentos",
                      formData,
                      { "Content-Type": "multipart/form-data" }
                    );
                  } catch (error) {
                    this.$swal.showValidationMessage(
                      `Request failed: ${error}`
                    );
                  }
                },
              }).then((result) => {
                if (result.isConfirmed) {
                  this.$emit("successData");
                } else if (result.dismiss === this.$swal.DismissReason.cancel) {
                  this.$emit("successData");
                }
              });
            } else {
              this.$emit("successData");
            }
          },
        });
      }
    },
    aplicarCompra() {
      let datos = { Id: this.Compra.Id };
      this.$alert.alertConfirm({
        action: "enviar a inventario",
        obj: "la compra",
        route: "AMC-Compras-applyCompra",
        data: datos,
        onSuccess: () => {
          //this.getPresentacionesByProduct()
          this.$emit("successData");
        },
      });
    },
    changeOrdenCompra() {
      if (this.Compra.ocm && this.tipoOrden == "O") {
        let ordenCompra = this.$pgsHelper.getById(
          this.OrdenesCompra,
          "id",
          this.Compra.ocm
        );
        this.Compra.amc = ordenCompra?.amc;
        this.Compra.adq = [];
        ordenCompra.req.forEach((req, index) => {
          let presentacion = this.$pgsHelper.getById(
            this.presentaciones,
            "prd",
            req.prd
          );
          this.Compra.adq.push({
            prs: presentacion.Id,
            nom: presentacion.nom,
            prd: req.prd,
            cnt: 1,
            pcu: { C: 0, M: "MXN" },
          });
        });
        this.editableAmc = false;
      } else {
        this.Compra.ocm = null;
        this.editableAmc = true;
      }
    },
    async getProveedores() {
      let proveedorArray = [];
      const database = await this.$store.getters.getFirebaseApp.database;
      const data = await database.queryBuilder("AMC/Provedores", []);
      if (data.exists()) {
        let arrayFactura = Object.entries(data.val());
        arrayFactura.forEach((element) => {
          proveedorArray.push({
            id: element[0],
            Nombre: element[1]["nom"],
            Rfc: element[1]["rfc"],
          });
        });
        this.Proveedores = proveedorArray;
      }
    },
    getProductUnidad(pres, amount) {
      if (!pres || !pres.presentacion || !amount) return "-";
      const cantidad = pres?.presentacion?.rdm ?? null;
      const producto = this.$pgsHelper.getById(
        this.global_prod,
        "id",
        pres.presentacion.prd
      );

      const unidad = producto?.Extra?.AYB?.UM || "PZA";

      return cantidad
        ? `${Number(cantidad * amount).toFixed(2)} ${unidad}`
        : unidad;
    },
    uploadFile() {
      this.acceptedDocuments = [".xml"];
      this.multipleDocuments = false;
      this.$nextTick(() => {
        const inputEl =
          this.$refs.hiddenFileInput.$el.querySelector('input[type="file"]');

        if (inputEl) {
          this.selectedFile = null;
          inputEl.click();
        }
      });
    },
    async onFileSelected() {
      if (!this.selectedFile) return;

      const fileType = this.selectedFile.type;
      const fileName = this.selectedFile.name.toLowerCase();

      if (fileType === "application/pdf" || fileName.endsWith(".pdf")) {
        this.archivoPdf = this.selectedFile;
        return;
      }

      if (
        fileType === "text/xml" ||
        fileType === "application/xml" ||
        fileName.endsWith(".xml")
      ) {
        this.Compra.adq = [];
        const reader = new FileReader();
        reader.onload = async (e) => {
          const xmlData = e.target.result;
          try {
            const parser = new XMLParser({
              ignoreAttributes: false,
              attributeNamePrefix: "@_",
              allowBooleanAttributes: true,
              parseTagValue: true,
            });
            const jsonObj = parser.parse(xmlData);
            this.dataFromXml = this.extractXmlData(jsonObj);
          } catch (e) {
            console.error(e);
          } finally {
            await this.findProveedor();
            await this.formatCompra();
          }
        };
        reader.readAsText(this.selectedFile);
      }
    },
    extractXmlData(json) {
      // Apartados
      const comprobante = json?.["cfdi:Comprobante"];
      const conceptos =
        json?.["cfdi:Comprobante"]?.["cfdi:Conceptos"]?.["cfdi:Concepto"];

      const proveedores = json?.["cfdi:Comprobante"]?.["cfdi:Emisor"];
      const resume = json?.["cfdi:Comprobante"];
      const document =
        json?.["cfdi:Comprobante"]?.["cfdi:Complemento"]?.[
          "tfd:TimbreFiscalDigital"
        ];

      if (!conceptos || !proveedores || !document || !comprobante) return [];

      const itemComprobante = Array.isArray(comprobante)
        ? comprobante
        : [comprobante];
      const itemConcepto = Array.isArray(conceptos) ? conceptos : [conceptos];
      const itemProveedor = Array.isArray(proveedores)
        ? proveedores
        : [proveedores];
      const itemResume = Array.isArray(resume) ? resume : [resume];
      const itemDoc = Array.isArray(document) ? document : [document];

      return {
        comprobante: itemComprobante.map((item) => ({
          Certificado: item["@_Certificado"] || "",
          CondicionesDePago: item["@_CondicionesDePago"] || "",
          Exportacion: item["@_Exportacion"] || "",
          Fecha: item["@_Fecha"] || "",
          Folio: item["@_Folio"] || "",
          FormaPago: item["@_FormaPago"] || "",
          LugarExpedicion: item["@_LugarExpedicion"] || "",
          MetodoPago: item["@_MetodoPago"] || "",
          Moneda: item["@_Moneda"] || "",
          NoCertificado: item["@_NoCertificado"] || "",
          Sello: item["@_Sello"] || "",
          SubTotal: item["@_SubTotal"] || "",
          TipoDeComprobante: item["@_TipoDeComprobante"] || "",
          Total: item["@_Total"] || "",
          Version: item["@_Version"] || "",
        })),
        conceptos: itemConcepto.map((item) => {
          let traslados =
            item?.["cfdi:Impuestos"]?.["cfdi:Traslados"]?.["cfdi:Traslado"];

          if (!traslados) traslados = [];
          if (!Array.isArray(traslados)) traslados = [traslados];

          return {
            ClaveProdServ: item["@_ClaveProdServ"] || "",
            NoIdentificacion: item["@_NoIdentificacion"] || "",
            Cantidad: item["@_Cantidad"] || "",
            ClaveUnidad: item["@_ClaveUnidad"] || "",
            Unidad: item["@_Unidad"] || "",
            Descripcion: item["@_Descripcion"] || "",
            ValorUnitario: item["@_ValorUnitario"] || "",
            Importe: item["@_Importe"] || "",
            ObjetoImp: item["@_ObjetoImp"] || "",
            Impuesto: traslados.map((tras) => ({
              Base: tras["@_Base"] || "",
              Impuesto: tras["@_Impuesto"] || "",
              TipoFactor: tras["@_TipoFactor"] || "",
              TasaOCuota: tras["@_TasaOCuota"] || "",
              Importe: tras["@_Importe"] || "",
            })),
          };
        }),
        proveedores: itemProveedor.map((item) => ({
          Rfc: item["@_Rfc"] || "",
          Nombre: item["@_Nombre"] || "",
          RegimenFiscal: item["@_RegimenFiscal"] || "",
        }))[0],
        resume: itemResume.map((item) => ({
          total: item["@_Total"],
        }))[0],
        document: itemDoc.map((item) => ({
          UUID: item["@_UUID"] || "",
          FechaTimbrado: item["@_FechaTimbrado"] || "",
        }))[0],
      };
    },
    findProveedor() {
      if (!this.dataFromXml) return;
      const xmlProveedor = this.dataFromXml.proveedores.Rfc;

      this.proveedor = this.Proveedores.find(
        (prv) => prv.Rfc === xmlProveedor
      ) || {
        Rfc: xmlProveedor,
        notFinded: true,
      };

      if (!this.proveedor.notFinded) {
        this.proveedor.notFinded = false;
      }
    },
    formatCompra() {
      this.XMLtotal = this.dataFromXml.resume.total;

      this.dataFromXml.conceptos.forEach((concepto) => {
        this.reqToAdd.proveedor = this.proveedor.Nombre;
        const presentacion = this.presentacionesByPvdId.pres.find((item) => {
          if (item.cfc) {
            return item.cfc.includes(String(concepto.NoIdentificacion));
          }

          return null;
        });

        this.reqToAdd.dpt = null;
        this.reqToAdd.amc = null;

        if (this.Compra.amc) this.reqToAdd.amc = this.Compra.amc;
        if (this.Compra.dpt) this.reqToAdd.dpt = this.Compra.dpt;

        if (!presentacion) {
          this.reqToAdd.prd = null;
          this.reqToAdd.producto = null;
          this.reqToAdd.block = false;
        } else {
          this.reqToAdd.producto = presentacion.nom;
          this.reqToAdd.prd = presentacion.prd;
          this.reqToAdd.prs = presentacion.Id;
          this.reqToAdd.block = true;
        }
        this.reqToAdd.cnt = this.$pgsHelper.formatNumber(concepto.Cantidad);
        this.reqToAdd.pcu.C = this.$pgsHelper.formatNumber(
          concepto.ValorUnitario
        );
        this.reqToAdd.prodNombre = concepto.Descripcion;
        this.reqToAdd.cfc = concepto.NoIdentificacion;
        this.reqToAdd.impuesto = concepto.Impuesto;

        this.Compra.adq.push(this.$pgsHelper.cloneObj(this.reqToAdd));
      });
    },
    presentacionesFiltradasPorPrd(prd) {
      if (!prd) return [];
      return (this.presentacionesByPvdId.pres || []).filter(
        (p) => p.prd === prd
      );
    },
    uploadPDF() {
      this.acceptedDocuments = [".pdf"];
      this.multipleDocuments = false;
      this.$nextTick(() => {
        const inputEl =
          this.$refs.hiddenFileInput.$el.querySelector('input[type="file"]');

        if (inputEl) {
          this.selectedFile = null;
          inputEl.click();
        }
      });
    },
    updateAllAmc() {
      this.Compra.adq.forEach((item) => {
        if (!this.changeDepAlmcList.includes(`${item.cfc}`))
          item.amc = this.Compra.amc;
      });
    },
    updateAllDpt() {
      this.Compra.adq.forEach((item) => {
        if (!this.changeDepAlmcList.includes(`${item.cfc}`))
          item.dpt = this.Compra.dpt;
      });
    },
    findDptInfo(id) {
      let departamentos = this.$store.getters.getPDVDepartamentos;
      return (
        departamentos.find((dep) => dep.id === id) || {
          Nombre: "No Asignado",
        }
      );
    },
    findAmcInfo(id) {
      return (
        this.origenes.find((org) => org.id === id) || {
          Nombre: "No Asignado",
        }
      );
    },
  },
  computed: {
    costoRefByPrs() {
      const map = {};
      const adq =
        this.Compra && Array.isArray(this.Compra.adq) ? this.Compra.adq : [];
      adq.forEach((item) => {
        // obtenemos la presentación para leer el rdm
        item.presentacion = this.$pgsHelper.getById(
          this.presentaciones,
          "Id",
          item.prs
        );
        const refUnit = this.getCostoRef(item); // costo por 1 medida/unidad
        const rdm = Number(item?.presentacion?.rdm);
        const factor = Number.isFinite(rdm) && rdm > 0 ? rdm : 1;
        // costo de referencia por presentación = costo unitario * rendimiento
        map[item.prs] = refUnit != null ? refUnit * factor : null;
      });
      return map;
    },
    sobreCostoByPrs() {
      const map = {};
      const adq =
        this.Compra && Array.isArray(this.Compra.adq) ? this.Compra.adq : [];
      // usamos el mapa ya ajustado por rendimiento
      const refsPorPresentacion = this.costoRefByPrs;
      adq.forEach((item) => {
        const refPres = refsPorPresentacion[item.prs]; // ref por presentación
        const price = Number(item && item.pcu && item.pcu.C);
        const hasPrice = Number.isFinite(price);
        // solo evaluamos si hay ref válida (>0) y precio válido
        map[item.prs] =
          refPres != null && refPres > 0 && hasPrice
            ? price > refPres * 2
            : null;
      });

      return map;
    },
    agrupadosPorProveedor() {
      if (this.Compra.adq.length > 0) {
        const grupos = this.Compra.adq.reduce((acc, item, index) => {
          const precioUnitario = Number(item.pcu.C);
          const precioImpesto = item.impuesto.reduce((sum, imp) => {
            return sum + Number(imp.Importe.replace(/,/g, ""));
          }, 0);
          const precioTotal = precioUnitario * item.cnt + precioImpesto;
          const unidadPrecio = item.pcu.M;
          const proveedorNombre = item.proveedor;
          item.globalIndex = index;
          item.precioTotal = precioTotal.toFixed(2);

          if (!acc[proveedorNombre]) {
            acc[proveedorNombre] = {
              proveedor: proveedorNombre,
              items: [],
              total: {},
            };
          }
          acc[proveedorNombre].items.push(item);

          if (!acc[proveedorNombre].total[unidadPrecio]) {
            acc[proveedorNombre].total[unidadPrecio] = 0;
          }
          acc[proveedorNombre].total[unidadPrecio] += precioTotal;

          return acc;
        }, {});

        return Object.values(grupos).map((grupo) => ({
          ...grupo,
          total: Object.entries(grupo.total)
            .map(
              ([moneda, total]) =>
                `${moneda}: $${this.$pgsHelper.formatNumber(total)}`
            )
            .join(", "),
        }));
      } else {
        return [];
      }
    },
    modulos() {
      let dep = [
        /*{ value: "", text: "Seleccione un modulo" }*/
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    total() {
      let total = 0;
      if (this.Compra.adq) {
        this.Compra.adq.forEach((ins) => {
          const impuesto = ins.impuesto.reduce((sum, imp) => {
            return sum + Number(imp.Importe.replace(/,/g, ""));
          }, 0);
          total += Number(ins.pcu.C) * ins.cnt + impuesto;
        });
      }

      if (total > 0) {
        return {
          compra: this.$pgsHelper.formatNumber(total),
          XML: this.$pgsHelper.formatNumber(this.XMLtotal),
        };
      }

      return {
        compra: 0,
        XML: 0,
      };
    },
    presentacionesGlobal() {
      let presentacionesSource = this.presentaciones;
      if (this.Compra.sts == "A") {
        presentacionesSource = this.presentacionesAll;
      }

      let presentaciones = [];
      if (presentacionesSource) {
        presentacionesSource.forEach((pres) => {
          let proveedor =
            this.Proveedores.find((prv) => prv.id === pres.pvd) || {};
          let producto = this.$pgsHelper.getById(
            this.global_prod,
            "id",
            pres.prd
          );

          if (producto?.Nombre) {
            pres.title =
              (producto.Nombre ?? "") +
              " - " +
              (pres.nom ?? "") +
              " - " +
              (pres.rdm ?? "") +
              " " +
              (producto.Extra?.AYB?.UM ?? "") +
              " - " +
              (proveedor.Nombre ?? "");

            if (pres.title && !pres.title.includes("undefined")) {
              presentaciones.push(pres);
            }
          }
        });
      }
      return presentaciones;
    },
    presentacionesByPvdId() {
      let presPrd = [];
      const presentaciones = this.presentacionesGlobal.filter(
        (pres) => pres.pvd == this.proveedor.id
      );

      presentaciones.forEach((prs) => presPrd.push(prs.prd));

      return { pres: presentaciones, prds: presPrd } || { pres: [], prds: [] };
    },
    insumosByPresPrd() {
      const insumos = this.global_prod.filter((ins) =>
        this.presentacionesByPvdId.prds.includes(ins.id)
      );

      return insumos || [];
    },
    global_prod() {
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      let productos = [];
      prod.forEach((element) => {
        if (
          (element.Tipo == "AYB-Insumo" || element.Tipo == "Producto") &&
          !element.Dlat
        ) {
          productos.push(element);
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });

      let data = productos;
      let sortReservations = this.$_.orderBy(data, "Orden", "asc");

      return sortReservations;
    },
  },
  watch: {},
  beforeMount: function () {},
  async mounted() {
    this.columnDefs = [
      {
        field: "nom",
        editable: true,
        cellEditor: "agSelectCellEditor",
        cellEditorParams: { values: this.presentaciones },
      },
      { field: "cnt", editable: true },
    ];
    this.getOrigenes();
    this.getOrdenesCompra();
    if (this.edit) {
      this.Compra = new Compra(this.dataEdit);
      this.notasProds = this.dataEdit.nts ? this.dataEdit.nts : "";
      if (this.Compra.ocm) {
        this.tipoOrden = "O";
      }
    } else {
      this.Compra = new Compra();
    }
    await this.getProveedores();
    await this.getCostos();
  },
};
</script>
